var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13935_1562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3C6.13333 3 3 6.13333 3 10C3 13.8667 6.13333 17 10 17C13.8667 17 17 13.8667 17 10C17 6.13333 13.8667 3.00667 10 3ZM13.1867 12.4133C13.06 12.5733 12.8667 12.6667 12.6667 12.6667C12.5133 12.6667 12.3667 12.6133 12.2533 12.52L9.58667 10.52C9.42667 10.3933 9.33333 10.2 9.33333 10V5.33333C9.33333 4.96667 9.63333 4.66667 10 4.66667C10.3667 4.66667 10.6667 4.96667 10.6667 5.33333V9.68L13.08 11.48C13.3667 11.7 13.42 12.1133 13.2 12.4C13.2 12.4 13.1933 12.4133 13.1867 12.4133Z",
    fill: "#209FED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C19.9933 4.48 15.52 0.00666667 10 0ZM10 18.38C5.37333 18.38 1.62 14.6267 1.62 10C1.62 5.37333 5.37333 1.62 10 1.62C14.6267 1.62 18.38 5.37333 18.38 10C18.38 14.6267 14.6267 18.3733 10 18.38Z",
    fill: "#209FED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13935_1562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.90344936b8663a88a20a0f8e9fdd7c0d.svg";
export { ForwardRef as ReactComponent };